import axios from 'axios'
import { END_POINT_LOGGER } from './index'

export const log = async (data) => {
  try {
    return await axios.request({
      method: 'post',
      url: `${END_POINT_LOGGER}`,
      data: data,
    })
  } catch (error) {
    console.error('Error in logging', error)
  }
}
